<div class="db-create-ai-assistant-finalize__steps">
  <h3 class="mb18 pl20">{{ 'text_generatingYourPersonalizedAiWebsite' | dbText }}</h3>
  <ul class="db-create-ai-assistant-finalize__steps-items">
    <li class="mb2" *ngFor="let step of steps"
        [ngClass]="{'process': step?.status === 'process','passed': step?.status === 'passed'}">
      <i *ngIf="step?.status === 'passed'" class="db-icon db-icon-ds-checkmark"></i>
      <span *ngIf="step?.status !== 'passed'" class=""
            [ngClass]="{
        'ds-spinner-circle spinner': step?.status === 'process',
        'db-icon db-icon-ds-checkmark todo': step?.status === 'todo'
       }"></span>
      <span class="db-create-ai-assistant-finalize__step-label ml10">{{step?.label | dbText}}</span>
    </li>
  </ul>
</div>

<div class="create-ai-image-wrap" *ngIf="!isMobile">
  <div class="create-ai-image-1">
      <img src="assets/images/ai/onboarding/ai-{{!!isEcommerce ? 'store' : 'informative'}}-dark.svg" alt="">
  </div>
  <div class="create-ai-image-2">
      <img src="assets/images/ai/onboarding/ai-{{!!isEcommerce ? 'store' : 'informative'}}-dark-full.svg" alt="">
  </div>
</div>
